
import ExportButton from '@/components/common/ExportButton.vue'
import ImportButton from '@/components/common/ImportButton.vue'
import MemberNameplate from '@/components/common/MemberNameplate.vue'
import StaffNameplate from '@/components/common/StaffNameplate.vue'
import { provinceOptions, cityMap, districtMap } from '@/utils/areaData'
// 对话原语（原生弹窗治理 Phase 1）：本文件 20 处原生弹窗（16 alert + 3 confirm + 1 prompt）全部迁到这里。
// A 类纯告知 → showMessage；B 类普通确认 → confirmAction；C 类危险确认（重置他人密码/归档用户）→ confirmDanger；
// D 类输入型（拒绝原因）→ showForm（唯一出口，不是"换个字符串输入框"）。
import { showMessage, confirmAction, confirmDanger, showForm } from '@/utils/dialog'

// 服务端文案直出（与仓内各页 catch 分支同口径）：优先 axios 的 response.data.message，
// 退到 Error.message，最后兜底。弹窗内 action 抛错时用它统一成中文原因。
function errText (e, fallback) {
  return (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || fallback
}

export default {
  name: 'UserManage',
  components: { ExportButton, ImportButton, MemberNameplate, StaffNameplate },
  data () {
    return {
      users: [],
      filterStatus: 'active',
      filterUserType: '',
      searchKeyword: '',
      stats: {
        pending: 0,
        active: 0,
        rejected: 0,
        blocked: 0,
        deleted: 0
      },
      pagination: {
        page: 1,
        limit: 20,
        total: 0
      },
      showAddModal: false,
      showEditModal: false,
      editForm: {
        id: '',
        name: '',
        role: 'user',
        status: 'active',
        phone: '',
        exp: 0,
        staff_exp: 0,
        nickname: '',
        avatar: '',
        wechat_id: '',
        wechat_nickname: '',
        shop_location: '',
        receiver_name: '',
        receiver_phone: '',
        province: '广西壮族自治区',
        city: '贺州市',
        district: '',
        address: ''
      },
      addForm: {
        phone: '',
        password: '',
        nickname: '',
        wechat_id: '',
        wechat_nickname: '',
        status: 'active'
      },
      showResetModal: false,
      resetUser: {},
      resetForm: {
        password: ''
      },
      showLevelModal: false,
      levelUser: {},
      levelForm: {
        newLevel: null,
        newExp: 0,
        reason: ''
      },
      showImportModal: false,
      importText: '',
      skipDuplicates: true,
      previewUsers: [],
      previewHeaders: [],
      importing: false,
      exporting: false,
      importResult: null,
      // 省市区三级：areaData.js 全国数据单一来源（与 Center/Cart 同源）
      provinceOptions,
      cityMap,
      districtMap,
      // 18级会员配置
      memberLevels: [
        { level: 1, name: '普通会员 I', minXp: 0, tier: 1 },
        { level: 2, name: '普通会员 II', minXp: 20, tier: 1 },
        { level: 3, name: '白银会员 I', minXp: 50, tier: 2 },
        { level: 4, name: '白银会员 II', minXp: 100, tier: 2 },
        { level: 5, name: '黄金会员 I', minXp: 180, tier: 3 },
        { level: 6, name: '黄金会员 II', minXp: 300, tier: 3 },
        { level: 7, name: '铂金会员 I', minXp: 500, tier: 4 },
        { level: 8, name: '铂金会员 II', minXp: 800, tier: 4 },
        { level: 9, name: '钻石会员 I', minXp: 1200, tier: 5 },
        { level: 10, name: '钻石会员 II', minXp: 1800, tier: 5 },
        { level: 11, name: '黑金会员 I', minXp: 2600, tier: 6 },
        { level: 12, name: '黑金会员 II', minXp: 3600, tier: 6 },
        { level: 13, name: '星耀会员 I', minXp: 5000, tier: 7 },
        { level: 14, name: '星耀会员 II', minXp: 7000, tier: 7 },
        { level: 15, name: '臻选会员 I', minXp: 10000, tier: 8 },
        { level: 16, name: '臻选会员 II', minXp: 15000, tier: 8 },
        { level: 17, name: '首席会员 I', minXp: 22000, tier: 9 },
        { level: 18, name: '首席会员 II', minXp: 30000, tier: 9 }
      ]
    }
  },
  created () {
    this.fetchUsers()
    this.fetchStats()
  },
  computed: {
    isSuperAdmin () { return this.$store.getters.isSuperAdmin },
    exportGroups () {
      const g = [
        { label: '用户', templates: [
          { value: 'customers', label: '客户', desc: '所有 customer 角色用户' }
        ]}
      ]
      if (this.isSuperAdmin) {
        g[0].templates.push({ value: 'staff', label: '员工', desc: '管理员/业务员/配送员' })
      }
      return g
    },
    importTemplates () {
      const t = [{ value: 'customers', label: '客户', desc: 'phone 去重 upsert' }]
      if (this.isSuperAdmin) t.push({ value: 'staff', label: '员工', desc: 'phone 去重 upsert' })
      return t
    },
    // 省市区联动（全国数据来自 areaData.js）
    provinceValues () { return this.provinceOptions.map(p => p.value) },
    cityOptions () { return (this.cityMap[this.editForm.province] || []) },
    districtOptions () { return (this.districtMap[this.editForm.city] || []) }
  },
  watch: {
    // 换省 → 城市不在该省列表则清空（原值兜底 option 已防显示丢值，但级联数据应对齐）
    'editForm.province' (nv, ov) {
      if (nv === ov) return
      if (this.editForm.city && this.cityOptions && !this.cityOptions.includes(this.editForm.city)) {
        this.editForm.city = ''
        this.editForm.district = ''
      }
    },
    'editForm.city' (nv, ov) {
      if (nv === ov) return
      if (this.editForm.district && this.districtOptions && !this.districtOptions.includes(this.editForm.district)) {
        this.editForm.district = ''
      }
    }
  },
  methods: {
    async fetchUsers () {
      // 过期保护：快速连续筛选/搜索时，旧响应晚到不许覆盖新响应（请求序号比对）
      const seq = this._fetchSeq = (this._fetchSeq || 0) + 1
      try {
        const params = { page: this.pagination.page, limit: this.pagination.limit }
        if (this.filterStatus) params.status = this.filterStatus
        if (this.filterUserType) params.user_type = this.filterUserType
        if (this.searchKeyword) params.keyword = this.searchKeyword

        const res = await this.axios.get('/admin/users', { params })
        if (seq !== this._fetchSeq) return
        if (res.data.code === 200) {
          this.users = res.data.data
          this.pagination = res.data.pagination
        }
      } catch (err) {
        console.error('获取用户失败:', err)
        // A 类（纯告知）：无返回值、执行流不依赖用户选择 → Notify，不弹窗
        showMessage('获取用户列表失败', { type: 'negative' })
      }
    },
    searchUsers () {
      this.pagination.page = 1
      this.fetchUsers()
    },
    clearSearch () {
      this.searchKeyword = ''
      this.pagination.page = 1
      this.fetchUsers()
    },
    async fetchStats () {
      try {
        const statuses = ['pending', 'active', 'rejected', 'blocked', 'deleted']
        for (const status of statuses) {
          const res = await this.axios.get('/admin/users', { params: { status, limit: 1 } })
          if (res.data.code === 200) {
            this.stats[status] = res.data.pagination.total
          }
        }
      } catch (err) {
        console.error('获取统计失败:', err)
      }
    },
    async createUser () {
      try {
        await this.axios.post('/admin/users', this.addForm)
        showMessage('用户创建成功', { type: 'positive' })
        this.showAddModal = false
        this.addForm = { phone: '', password: '', nickname: '', wechat_id: '', wechat_nickname: '', status: 'active' }
        this.fetchUsers()
        this.fetchStats()
      } catch (err) {
        console.error('创建用户失败:', err)
        showMessage(errText(err, '创建用户失败'), { type: 'negative' })
      }
    },
    async updateStatus (userId, status) {
      const actionText = { active: '通过', pending: '恢复审核', rejected: '拒绝', blocked: '禁用' }[status]
      if (status === 'rejected') {
        // 迁移（原生弹窗治理 Phase 1）：window.prompt → showForm（D 类唯一出口）。
        // 判定顺序先判 D：这一步用户要**提供内容**（原因）才能继续，不是二值选择。
        // 「拒绝必须有原因」改由字段级 required 强制——原实现只把 null（点取消）当取消，
        // 直接点确定提交空串也放行 → 后端收到空原因，是审计 §5.6 点名的既存缺陷。
        // 原因会展示给申请人，故写进 help；请求收进 onSubmit（弹窗内 loading 防双击、失败留现场）。
        await showForm({
          parent: this,
          title: '拒绝用户申请',
          message: '拒绝后申请人会看到该原因，请写清楚。',
          fields: [{
            key: 'reject_reason',
            label: '拒绝原因',
            type: 'textarea',
            required: true,
            placeholder: '请填写拒绝原因（必填）',
            help: '将记录并展示给申请人'
          }],
          okLabel: '确认拒绝',
          onSubmit: async (values) => {
            try {
              await this.axios.put(`/admin/users/${userId}/status`, { status, reject_reason: String(values.reject_reason).trim() })
            } catch (e) { throw new Error(errText(e, '操作失败')) }
            showMessage('操作成功', { type: 'positive' })
            this.fetchUsers()
            this.fetchStats()
          }
        })
        return
      }
      // 其它状态（通过/恢复审核/禁用）都是**可再改**的状态切换（无物理删除、无不可逆后果）→
      // B 类普通确认，主色蓝，不用危险红（审计 §3.4 把「禁用用户」明确划在 B）。
      await confirmAction({
        parent: this,
        title: `${actionText}该用户`,
        message: `确定要${actionText}该用户吗？`,
        okLabel: actionText,
        semantic: 'primary',
        action: async () => {
          try {
            await this.axios.put(`/admin/users/${userId}/status`, { status, reject_reason: null })
          } catch (e) { throw new Error(errText(e, '操作失败')) }
          showMessage('操作成功', { type: 'positive' })
          this.fetchUsers()
          this.fetchStats()
        }
      })
    },
    async editUser (user) {
      // 获取用户完整信息
      try {
        const res = await this.axios.get(`/admin/users/${user.id}`)
        if (res.data.code === 200) {
          const u = res.data.data
          this.editForm = {
            id: u.id,
            // 只读展示：注册编号按注册顺序分配、永不复用，后端 allowedFields 不含此字段，仅查看
            registration_no: u.registration_no || null,
            name: u.name || '',
            role: u.role || 'user',
            status: u.status || 'active',
            phone: u.phone || '',
            exp: u.exp || 0,
            staff_exp: u.staff_exp || 0,
            admin_level: u.admin_level || 0,
            nickname: u.nickname || '',
            avatar: u.avatar || '',
            wechat_id: u.wechat_id || '',
            wechat_nickname: u.wechat_nickname || '',
            shop_location: u.shop_location || '',
            receiver_name: u.receiver_name || '',
            receiver_phone: u.receiver_phone || '',
            province: u.province || '广西壮族自治区',
            city: u.city || '贺州市',
            district: u.district || '',
            address: u.address || ''
          }
          this.showEditModal = true
        }
      } catch (err) {
        console.error('获取用户信息失败:', err)
        showMessage('获取用户信息失败', { type: 'negative' })
      }
    },
    async saveUserEdit () {
      try {
        await this.axios.put(`/admin/users/${this.editForm.id}`, {
          phone: this.editForm.phone,
          name: this.editForm.name,
          role: this.editForm.role,
          status: this.editForm.status,
          staff_exp: this.editForm.staff_exp,
          nickname: this.editForm.nickname,
          avatar: this.editForm.avatar,
          wechat_id: this.editForm.wechat_id,
          wechat_nickname: this.editForm.wechat_nickname,
          shop_location: this.editForm.shop_location,
          receiver_name: this.editForm.receiver_name,
          receiver_phone: this.editForm.receiver_phone,
          province: this.editForm.province,
          city: this.editForm.city,
          district: this.editForm.district,
          address: this.editForm.address
        })
        showMessage('保存成功', { type: 'positive' })
        this.showEditModal = false
        this.fetchUsers()
      } catch (err) {
        console.error('保存失败:', err)
        showMessage(errText(err, '保存失败'), { type: 'negative' })
      }
    },
    openResetModal (user) {
      this.resetUser = user
      this.resetForm.password = ''
      this.showResetModal = true
    },
    async resetPassword () {
      // Security-2E：密码只进请求体，不落日志/localStorage
      // 迁移（原生弹窗治理 Phase 1）：confirm → confirmDanger。
      // 危险点：覆盖**他人的登录凭据** (b)——旧密码立即失效，用户只能用新密码登录。
      // 安全纪律：密码此刻已在 resetForm.password 里，二次确认**不回显**它（审计 §5.6），
      // 成功后也不展示明文（§3.5：密码不得明文回显）——提示管理员把新密码告知用户即可。
      await confirmDanger({
        parent: this,
        title: '重置用户密码',
        message: `确认将用户 ${this.resetUser.phone} 的密码重置为新输入的密码？`,
        consequence: '该用户的旧密码立即失效，只能用新密码登录。请确认已把新密码准确交付给用户——此处不会显示密码明文。',
        okLabel: '重置密码',
        action: async () => {
          try {
            await this.axios.put(`/admin/users/${this.resetUser.id}/password`, { password: this.resetForm.password })
          } catch (e) { throw new Error(errText(e, '重置密码失败')) }
          showMessage('密码重置成功，请将新密码告知用户', { type: 'positive' })
          this.showResetModal = false
          this.resetForm.password = ''
        }
      })
    },
    async deleteUser (userId) {
      // 归档（软删除）：后端将 status 置为 deleted 并记录 deleted_at，记录保留，可在"归档"筛选中查看
      // 迁移（原生弹窗治理 Phase 1）：confirm → confirmDanger。
      // 危险点：归档后**该账号无法登录** (b)——记录虽保留、后台可查，但对用户侧等同于失去账号。
      await confirmDanger({
        parent: this,
        title: '归档用户',
        message: '确定要归档该用户吗？',
        consequence: '归档后该账号无法登录；记录保留，可在「归档」筛选中查看。',
        okLabel: '归档',
        action: async () => {
          try {
            await this.axios.delete(`/admin/users/${userId}`)
          } catch (e) { throw new Error(errText(e, '归档失败')) }
          showMessage('已归档', { type: 'positive' })
          this.showEditModal = false
          this.fetchUsers()
          this.fetchStats()
        }
      })
    },
    changePage (page) {
      this.pagination.page = page
      this.fetchUsers()
    },
    statusText (status) {
      const map = {
        pending: '待审核',
        active: '正常',
        rejected: '已拒绝',
        blocked: '已禁用',
        deleted: '归档'
      }
      return map[status] || status
    },
    sourceText (source, detail) {
      const map = {
        referral: '老客户推荐',
        salesman: '业务员推广',
        store: '线下门店',
        other: '其他'
      }
      const text = map[source] || source || '-'
      if (detail && source === 'other') {
        return `${text}: ${detail}`
      }
      return text
    },
    formatDate (date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      return d.toLocaleString('zh-CN')
    },
    // staff 身份（admin/operator/courier）— 与普通用户会员体系分离
    isStaffRole (role) {
      return ['admin', 'operator', 'courier'].includes(role)
    },
    // staff 等级 1-4（成员/熟练/资深/核心），按 staff_exp 推导
    getStaffLevelNum (user) {
      const xp = user.staff_exp || 0
      if (xp >= 800) return 4
      if (xp >= 300) return 3
      if (xp >= 100) return 2
      return 1
    },
    // 根据经验值获取会员等级信息
    getMemberLevelByExp (exp) {
      exp = exp || 0
      for (let i = this.memberLevels.length - 1; i >= 0; i--) {
        if (exp >= this.memberLevels[i].minXp) {
          return this.memberLevels[i]
        }
      }
      return this.memberLevels[0]
    },
    // 获取用户会员等级名称
    getMemberLevelName (user) {
      // 如果管理员设置了固定等级
      if (user.admin_level) {
        const level = this.memberLevels.find(l => l.level === user.admin_level)
        if (level) return level.name
      }
      // 按经验值计算
      const level = this.getMemberLevelByExp(user.exp)
      return level.name
    },
    // 获取用户会员等级编号
    getMemberLevelNum (user) {
      // 如果管理员设置了固定等级
      if (user.admin_level) {
        return user.admin_level
      }
      // 按经验值计算
      const level = this.getMemberLevelByExp(user.exp)
      return level.level
    },
    // 获取用户会员档位（用于样式）
    getMemberTier (user) {
      // 如果管理员设置了固定等级
      if (user.admin_level) {
        const level = this.memberLevels.find(l => l.level === user.admin_level)
        if (level) return level.tier
      }
      // 按经验值计算
      const level = this.getMemberLevelByExp(user.exp)
      return level.tier
    },
    // 打开等级调整弹窗
    openLevelModal (user) {
      this.levelUser = user
      this.levelForm = {
        newLevel: user.admin_level || null,
        newExp: user.exp || 0,
        reason: ''
      }
      this.showLevelModal = true
    },
    // 调整用户等级
    async adjustLevel () {
      // A 类（纯告知）：表单已有 required，这里是防御性兜底 → warning Notify
      if (!this.levelForm.reason) {
        showMessage('请填写调整原因', { type: 'warning' })
        return
      }
      try {
        const res = await this.axios.post('/admin/user/adjust-level', {
          userId: this.levelUser.id,
          newLevel: this.levelForm.newLevel,
          newExp: this.levelForm.newExp,
          reason: this.levelForm.reason
        })
        if (res.data.code === 200) {
          showMessage('等级调整成功', { type: 'positive' })
          this.showLevelModal = false
          this.fetchUsers()
        }
      } catch (err) {
        console.error('调整等级失败:', err)
        showMessage(errText(err, '调整等级失败'), { type: 'negative' })
      }
    },
    // 导出用户
    async exportUsers () {
      this.exporting = true
      try {
        const params = {}
        if (this.filterStatus) params.status = this.filterStatus
        if (this.searchKeyword) params.keyword = this.searchKeyword

        const token = localStorage.getItem('token')
        const baseUrl = this.axios.defaults.baseURL || ''
        const queryString = new URLSearchParams(params).toString()
        const url = `${baseUrl}/admin/users/export${queryString ? '?' + queryString : ''}`

        const response = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` }
        })
        const blob = await response.blob()
        const downloadUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = downloadUrl
        a.download = `users_${new Date().toISOString().split('T')[0]}.csv`
        a.click()
        window.URL.revokeObjectURL(downloadUrl)
      } catch (err) {
        console.error('导出失败:', err)
        showMessage('导出失败', { type: 'negative' })
      } finally {
        this.exporting = false
      }
    },
    // 下载导入模板
    async downloadTemplate () {
      const token = localStorage.getItem('token')
      const baseUrl = this.axios.defaults.baseURL || ''
      const url = `${baseUrl}/admin/users/template`

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      })
      const blob = await response.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = downloadUrl
      a.download = 'user_import_template.csv'
      a.click()
      window.URL.revokeObjectURL(downloadUrl)
    },
    // 处理文件上传
    handleFileUpload (e) {
      const file = e.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = (event) => {
        this.importText = event.target.result
        this.previewImport()
      }
      reader.readAsText(file, 'UTF-8')
    },
    // 解析CSV
    parseCSV (text) {
      const lines = text.trim().split('\n')
      if (lines.length < 2) return []

      // 解析表头
      const headers = this.parseCSVLine(lines[0])
      const users = []

      for (let i = 1; i < lines.length; i++) {
        const values = this.parseCSVLine(lines[i])
        if (values.length === 0 || (values.length === 1 && values[0] === '')) continue

        const user = {}
        headers.forEach((h, idx) => {
          user[h.trim()] = values[idx] || ''
        })
        users.push(user)
      }

      return { headers, users }
    },
    // 解析CSV行（处理引号内的逗号）
    parseCSVLine (line) {
      const result = []
      let current = ''
      let inQuotes = false

      for (let i = 0; i < line.length; i++) {
        const char = line[i]
        if (char === '"') {
          if (inQuotes && line[i + 1] === '"') {
            current += '"'
            i++
          } else {
            inQuotes = !inQuotes
          }
        } else if (char === ',' && !inQuotes) {
          result.push(current.trim())
          current = ''
        } else {
          current += char
        }
      }
      result.push(current.trim())
      return result
    },
    // 预览导入数据
    previewImport () {
      this.importResult = null
      if (!this.importText.trim()) {
        this.previewUsers = []
        this.previewHeaders = []
        return
      }

      const { headers, users } = this.parseCSV(this.importText)
      this.previewHeaders = headers
      this.previewUsers = users
    },
    // 执行导入
    async doImport () {
      if (this.previewUsers.length === 0) return

      this.importing = true
      this.importResult = null

      try {
        const res = await this.axios.post('/admin/users/import', {
          users: this.previewUsers,
          skipDuplicates: this.skipDuplicates
        })

        if (res.data.code === 200) {
          this.importResult = res.data
          this.fetchUsers()
          this.fetchStats()
        }
      } catch (err) {
        console.error('导入失败:', err)
        this.importResult = {
          message: err.response?.data?.message || '导入失败',
          failed: 1,
          errors: [{ row: 0, error: err.response?.data?.message || '网络错误' }]
        }
      } finally {
        this.importing = false
      }
    },
    // 关闭导入弹窗
    closeImportModal () {
      this.showImportModal = false
      this.importText = ''
      this.previewUsers = []
      this.previewHeaders = []
      this.importResult = null
    }
  }
}
